<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <p class=".title ma-2">Add a line </p>
            <v-form ref="addHklr" v-model="addHklrValid">
                <v-row no-gutters v-if="betreft.toUpperCase() !== 'KLPT'">
                    <v-col class="pa-2">
                        <v-select v-model="fcti_code" required :items="fcti_codeKeuzes" item-value="fcti_code" item-text="fctitaal_oms" label="Item" dense :rules="fcti_codeRules"></v-select>
                    </v-col>
                </v-row>

                <v-row v-if="hklr.betreft == 'Payment'" no-gutters>
                    <v-col class="pa-2">
                        <v-menu
                            v-model="hklr_dtmenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            readonly 
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="hklr_dt" label="Date" v-on="on" :rules="hklr_dtRules"></v-text-field>
                            </template>
                            <v-date-picker v-model="hklr_dt" :first-day-of-week="1" @input="hklr_dtmenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col>
                </v-row>

                <v-row v-if="hklr.betreft == 'Payment' && hobo_codeKeuzes.length > 0" no-gutters>
                    <v-col class="pa-2">
                        <v-select v-model="hobo_rowid" :items="hobo_codeKeuzes" item-value="hobo_rowid" item-text="hobo_methode_oms" label="Online payment" dense></v-select>
                    </v-col>
                </v-row>

                <v-row  no-gutters v-if="fcti_code === 'v2b'">
                    <v-col class="pa-2">
                        <v-text-field v-model="akcc_code" label="Discount code" dense></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="fcti_code === 'v2b'">
                    <v-col class="pa-2">
                        <v-text-field v-model="hklr_bedrag" required label="Amount" :prefix=hklr.valu_code type="number" :rules="hklr_bedragRules2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-else>
                    <v-col class="pa-2">
                        <v-text-field v-model="hklr_bedrag" required label="Amount" :prefix=hklr.valu_code type="number" :rules="hklr_bedragRules1"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
            <v-card-actions>
                <v-btn class="primary mx-2" small @click="calcDiscount" v-if="fcti_code === 'v2b'">Calculate Discount</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHklr" :disabled="!addHklrValid">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                addHklrValid: false,
                huov_encrid: null,
                fcti_code: '',
                akcc_code: '',
                hklr_bedrag: null,
                fcti_codeKeuzes: [],
                hobo_codeKeuzes: [],
                hklr: {},
                hklr_dtmenu: false,
                betreft: '',
                fcti_codeRules: [
                    v => (v && v.length >= 1) || "An fcti code is required"
                ],
                hklr_dtRules: [
                    v => (v && v.length >= 10) || "A Date is required"
                ],   
                hklr_bedragRules1: [
                    v => {
                        if (!isNaN(parseFloat(v))) return true;
                        return  "An amount needs to be given (0 is allowed)";
                    }
                ], 
                hklr_bedragRules2: [
                    v => {
                        if (!isNaN(parseFloat(v)) && (v > 0 || v < 0)) return true;
                        return  "An amount needs to be <> 0";
                    }
                ],   
            }
        },
        methods: {
            open(huov_encrid,betreft) {
                // console.log('betreft', betreft)
                var deze = this;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.betreft = betreft;
                this.huov_encrid = huov_encrid;
                this.fcti_codeKeuzes.length = 0;
                this.hobo_codeKeuzes.length = 0;
                this.hklr_dt = '';
                this.hobo_rowid = '';
                this.hklr_bedrag = '';
                // Set fcti_code based on betreft value
                if (betreft.toUpperCase() === 'KLPT') {
                    this.fcti_code = 'Klpt';
                } else {
                    this.fcti_code = '';
                }
                this.hklr = {};
                this.$axios.post("ares/json/ares/huov/hklr/getHuovToAddHklr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuovToAddHklr"
                    },
                    getHuovToAddHklr: {
                        huov_encrid: huov_encrid,
                        betreft: betreft
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hklr = res.data.getHuovToAddHklr;
                        res.data.getHuovToAddHklr.fcti_codeKeuzes.forEach(function(fcti) {
                            deze.fcti_codeKeuzes.push(fcti); 
                        });
                        if (res.data.getHuovToAddHklr.hobo_codeKeuzes) {
                            res.data.getHuovToAddHklr.hobo_codeKeuzes.forEach(function(hobo) {
                                deze.hobo_codeKeuzes.push(hobo); 
                            });
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            addHklr() { 
                this.$axios.post("ares/json/ares/huov/hklr/addHklr2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHklr"
                    },
                    addHklr: {
                        huov_encrid: this.huov_encrid,
                        fcti_code: this.fcti_code,
                        hklr_dt: this.hklr_dt,
                        hobo_rowid: this.hobo_rowid,
                        akcc_code: this.akcc_code,
                        hklr_bedrag: parseFloat(this.hklr_bedrag)
                    }
                }).then(res => {
                    // console.log('res.data', res.data)
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning",
                        }); 
                    } else { 
                        setTimeout(() => { this.$router.reload('/huov/onHuov/' + res.data.addHklr.huov_encrid); }, 2000);              
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHklr.text,
                            color: res.data.addHklr.color
                        }); 
                        this.dialog = false;
                    }
                });
            },
            calcDiscount() { 
                this.$axios.post("ares/json/ares/huov/hklr/calcHklrDiscount.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "calcHklrDiscount"
                    },
                    calcHklrDiscount: {
                        huov_encrid: this.huov_encrid,
                        cDiscountCode: this.akcc_code
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        }); 
                    } else {           
                        this.hklr_bedrag = res.data.calcHklrDiscount;
                        this.$refs.addHklr.resetValidation();
                        this.$refs.addHklr.validate();
                    }
                });
            },
        }
    }
</script>

